import styled from "styled-components";
import {GameJackpotBarContainerDefaultBox} from "./game-jackpot-bar-container.default.box";

export const GameJackpotBarContainerCasino888Box = styled(GameJackpotBarContainerDefaultBox)`
    background-size: 103%;
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_in_game_bar_png.toString()}),
    linear-gradient(90deg, #330073 0.43%, #71009A 99.73%);
`;
